module.exports = __webpack_public_path__ + "media/images/facebook-white@2x-0fa0427e7491f8a98e7ca4d7d771002f.png";